if (document.querySelector('.event-discount__timer')) {
	document.addEventListener('DOMContentLoaded', function () {
		function startCountdown(targetDate) {
			function updateCountdown() {
				const now = new Date().getTime();
				const distance = targetDate - now;

				if (distance <= 0) {
					document.getElementById('event-discount-timer').innerHTML = `
                        <div><span>0</span> Days</div>
                        <div><span>0</span> Hours</div>
						<div><span>0</span> Minutes</div>
                    `;
					clearInterval(timerInterval);
					return;
				}

				const days = Math.floor(distance / (1000 * 60 * 60 * 24));
				const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				// const seconds = Math.floor((distance % (1000 * 60)) / 1000);

				document.getElementById('event-discount-timer').innerHTML = `
                    <div><span>${days}</span> Days</div>
                    <div><span>${hours}</span> Hours</div>
					<div><span>${minutes}</span> Minutes</div>
                `;
			}

			const timerInterval = setInterval(updateCountdown, 1000);
			updateCountdown();
		}

		function normalizeDateString(dateString) {
			return dateString.replace(/\b(\d{4})-(\d{1,2})-(\d{1,2})/, (match, year, month, day) => {
				month = month.padStart(2, '0');
				day = day.padStart(2, '0');
				return `${year}-${month}-${day}`;
			});
		}

		const element = document.querySelector('.event-discount__timer');
		let dataDateTime = element?.getAttribute('data-datetime') || new Date().toISOString();
		dataDateTime = normalizeDateString(dataDateTime);

		const countdownTarget = new Date(dataDateTime);
		startCountdown(countdownTarget);
	});
}
